'use client';
// First-party page-view tracker (works when GA is ad-blocked). Mounted once in app/layout.tsx.
// Same route-change pattern as GoogleAnalytics.tsx: usePathname + useSearchParams under Suspense.
// Ids and the beacon itself live in src/lib/analytics/client.ts; the server side is /api/track.

import { Suspense, useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { trackPageview } from '@/lib/analytics/client';

function PageViews() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastRef = useRef<string>('');

  useEffect(() => {
    if (!pathname || pathname.startsWith('/admin')) return;
    const qs = searchParams?.toString() ?? '';
    const key = `${pathname}?${qs}`;
    // React strict-mode / re-renders with identical location must not double-count.
    if (lastRef.current === key) return;
    lastRef.current = key;
    trackPageview(pathname, qs ? `?${qs}` : '');
  }, [pathname, searchParams]);

  return null;
}

export default function VisitorTracker() {
  return (
    <Suspense fallback={null}>
      <PageViews />
    </Suspense>
  );
}
